// extracted by mini-css-extract-plugin
export var editInput = "_f6-0";
export var editInputCompact = "_f6-2";
export var editInputLarge = "_f6-1";
export var editInputSmall = "_f6-3";